import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer";
import office from "../../Assets/Consultant/office.png";
import createProfile from "../../Assets/Consultant/CreateProfile.png";
import getPaid from "../../Assets/Consultant/GetPaid.png";
import landingImageConsultant from "../../Assets/Consultant/landingImageConsultant.png";
import Navbar from "../../Components/Navbar";
import { useSelector } from "react-redux";
import { roles } from "../../Utils/constants";
import Swal from "sweetalert2";

export default function Consultant() {
  const { value: isLoggedIn, role } = useSelector((state) => state.user);
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <div className="text-white text-2xl py-8 lg:px-12 sm:px-12 px-4 flex items center bg-[#2EBAA3]">
        <span>Consultant</span>
      </div>
      {/* Consultant Landing Page */}
      <div>
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="flex flex-col-reverse lg:flex-row text-center mx-4 md:mx-12"

        >
          <div className="flex flex-col space-y-10 max-w-screen-lg py-24">
            <div className="text-center lg:text-start">
              <span
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "42px",
                  lineHeight: "55px",
                }}
              >
                ProLegion for Consultants
              </span>
            </div>
            <div
              className="text-center font-extralight lg:text-justify"
              style={{
                fontSize: "20px",
                lineHeight: "27px",
              }}
            >
              Prolegion provides a platform for consultants to search for jobs,
              submit timesheets, and be paid for their work. Consultants can use
              Prolegion to reduce their workload, manage their money more
              effectively, and communicate and collaborate with vendors and
              clients to strengthen connections and expand business
              opportunities.
            </div>
            <div className="flex lg:justify-start justify-center">
              <button
                className="w-[191px] h-[50px] hover:h-[53px] hover:w-[195]"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  if (isLoggedIn) {
                    if (role === roles.client) navigate("/dashboard");
                    else
                      Swal.fire(
                        "",
                        `You are already logged in as a ${role.toLowerCase()}<br>To try the client section, please logout first`,
                        "info"
                      );
                  } else navigate("/signup");
                }}
              >
                <button
                  style={{
                    border: "2px solid #139588",
                    borderRadius: "25px",
                    color: "#139588",
                  }}
                  className="w-[191px] h-[50px] hover:h-[53px] hover:w-[195] mt-[2px] shadow-md hover:shadow-lg"
                >
                  Try for free
                </button>
              </button>
            </div>
          </div>
          <div className="mt-3 lg:ml-20">
            <img
              alt="landingImage"
              className="object-contain"
              src={landingImageConsultant}
            />
          </div>
        </div>
      </div>
      {/* How we serve */}
      <div className="font-[Roboto] text-3xl lg:text-left text-center lg:px-12 py-8">
        How We Serve You
      </div>
      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row-reverse justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-3/5 lg:ml-10 lg:pr-40">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Create profile and find jobs
            </div>
            <div className="lg:ml-12 space-y-4 font-extralight text-[18px] leading-[27px] lg:text-justify text-center">
              Consultants can build a profile on Prolegion that highlights their
              abilities, expertise, and availability. They can also update their
              profile with their employment history and references. Consultants
              can use the platform to look for employment based on their
              abilities and preferences. Users can directly apply for jobs on
              the platform and contact with suppliers about job details and
              criteria
            </div>
          </div>
          <div className="flex justify-center max-h-[400px] lg:w-2/5">
            <img alt="profile" className="px-4 sm:px-0 object-contain" src={createProfile} />
          </div>
        </div>
      </div>
      {/* Timesheet & Invoices */}
      <div
        style={{ display: "flex", justifyContent: "center" }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-7/12">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Realtime collaboration
            </div>
            <div className="lg:mr-12 space-y-4 font-extralight lg:text-justify text-center text-[18px] leading-[27px]">
              The platform provided by Prolegion makes it simple for consultants
              to communicate with their vendors and clients. When a consultant
              is allocated to a job, they can communicate directly with the
              vendor and customer through the platform. They can discuss
              employment requirements, share project specifics, and provide
              progress updates. Prolegion also allows consultants to create
              timesheets and invoices, which vendors and clients can examine and
              approve. This open and efficient communication method ensures that
              everyone is on the same page and allows consultants to develop
              stronger relationships with their vendors and clients. Consultants
              that use Prolegion may interact more efficiently with their
              clients and providers, delivering high-quality work on time and
              within budget.
            </div>
          </div>
          <div className="flex justify-center lg:w-5/12 max-h-[500px]">
            <img alt="office" className="px-4 sm:px-0 object-contain" src={office} />
          </div>
        </div>
      </div>
      {/* Pay vendors */}
      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row-reverse justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-3/5">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Manage timesheets and get paid
            </div>
            <div className="lg:ml-12 space-y-4 font-extralight lg:text-justify text-center text-[18px] leading-[27px]">
              Prolegion offers consultants a simple and effective way to submit
              timesheets and get paid on time. Whenever a work is completed, a
              consultant can easily produce and submit a timesheet using the
              Prolegion platform. After reviewing and approving the timesheet,
              the vendor can prepare an invoice for the client based on the
              approved hours worked. The vendor can pay the consultant based on
              the timesheet supplied if the client approves the timesheet and
              invoice. The platform from Prolegion streamlines the entire
              process, ensuring correctness, transparency, and on-time payments.
              Consultants can concentrate on their work, certain that they will
              be paid fairly and on time, while vendors and clients can rest
              assured that the invoicing and payment process is streamlined and
              quick.
            </div>
          </div>
          <div className="flex justify-center lg:w-2/5 max-h-[400px]">
            <img alt="money" className="px-4 sm:px-0 object-contain" src={getPaid} />
          </div>
        </div>
      </div>
      {/* Register Button */}/
      <div className="py-16">
        <div className="flex justify-center">
          <button
            onClick={() => navigate(isLoggedIn ? "/dashboard" : "/signup")}
            style={{
              width: "191px",
              height: "50px",
              background: "#139588",
              borderRadius: "25px",
              color: "white",
            }}
          >
            Register
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
